import { __assign } from "tslib";
// Partition default templates
var AWS_TEMPLATE = "s3.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "s3.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "s3.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "s3.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "s3.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-northeast-3",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2",
]);
var AWS_CN_REGIONS = new Set(["cn-north-1", "cn-northwest-1"]);
var AWS_ISO_REGIONS = new Set(["us-iso-east-1"]);
var AWS_ISO_B_REGIONS = new Set(["us-isob-east-1"]);
var AWS_US_GOV_REGIONS = new Set(["us-gov-east-1", "us-gov-west-1"]);
export var defaultRegionInfoProvider = function (region, options) {
    var regionInfo = undefined;
    switch (region) {
        // First, try to match exact region names.
        case "accesspoint-af-south-1":
            regionInfo = {
                hostname: "s3-accesspoint.af-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-ap-east-1":
            regionInfo = {
                hostname: "s3-accesspoint.ap-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-ap-northeast-1":
            regionInfo = {
                hostname: "s3-accesspoint.ap-northeast-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-ap-northeast-2":
            regionInfo = {
                hostname: "s3-accesspoint.ap-northeast-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-ap-northeast-3":
            regionInfo = {
                hostname: "s3-accesspoint.ap-northeast-3.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-ap-south-1":
            regionInfo = {
                hostname: "s3-accesspoint.ap-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-ap-southeast-1":
            regionInfo = {
                hostname: "s3-accesspoint.ap-southeast-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-ap-southeast-2":
            regionInfo = {
                hostname: "s3-accesspoint.ap-southeast-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-ca-central-1":
            regionInfo = {
                hostname: "s3-accesspoint.ca-central-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-cn-north-1":
            regionInfo = {
                hostname: "s3-accesspoint.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn",
            };
            break;
        case "accesspoint-cn-northwest-1":
            regionInfo = {
                hostname: "s3-accesspoint.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn",
            };
            break;
        case "accesspoint-eu-central-1":
            regionInfo = {
                hostname: "s3-accesspoint.eu-central-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-eu-north-1":
            regionInfo = {
                hostname: "s3-accesspoint.eu-north-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-eu-south-1":
            regionInfo = {
                hostname: "s3-accesspoint.eu-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-eu-west-1":
            regionInfo = {
                hostname: "s3-accesspoint.eu-west-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-eu-west-2":
            regionInfo = {
                hostname: "s3-accesspoint.eu-west-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-eu-west-3":
            regionInfo = {
                hostname: "s3-accesspoint.eu-west-3.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-me-south-1":
            regionInfo = {
                hostname: "s3-accesspoint.me-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-sa-east-1":
            regionInfo = {
                hostname: "s3-accesspoint.sa-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-us-east-1":
            regionInfo = {
                hostname: "s3-accesspoint.us-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-us-east-2":
            regionInfo = {
                hostname: "s3-accesspoint.us-east-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-us-gov-east-1":
            regionInfo = {
                hostname: "s3-accesspoint.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
            };
            break;
        case "accesspoint-us-gov-west-1":
            regionInfo = {
                hostname: "s3-accesspoint.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
            };
            break;
        case "accesspoint-us-west-1":
            regionInfo = {
                hostname: "s3-accesspoint.us-west-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "accesspoint-us-west-2":
            regionInfo = {
                hostname: "s3-accesspoint.us-west-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "af-south-1":
            regionInfo = {
                hostname: "s3.af-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "s3.ap-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "s3.ap-northeast-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "s3.ap-northeast-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-northeast-3":
            regionInfo = {
                hostname: "s3.ap-northeast-3.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "s3.ap-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "s3.ap-southeast-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "s3.ap-southeast-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "aws-global":
            regionInfo = {
                hostname: "s3.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1",
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "s3.ca-central-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "s3.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn",
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "s3.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn",
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "s3.eu-central-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "s3.eu-north-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "s3.eu-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "s3.eu-west-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "s3.eu-west-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "s3.eu-west-3.amazonaws.com",
                partition: "aws",
            };
            break;
        case "fips-accesspoint-ca-central-1":
            regionInfo = {
                hostname: "s3-accesspoint-fips.ca-central-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "fips-accesspoint-us-east-1":
            regionInfo = {
                hostname: "s3-accesspoint-fips.us-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "fips-accesspoint-us-east-2":
            regionInfo = {
                hostname: "s3-accesspoint-fips.us-east-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "fips-accesspoint-us-gov-east-1":
            regionInfo = {
                hostname: "s3-accesspoint-fips.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
            };
            break;
        case "fips-accesspoint-us-gov-west-1":
            regionInfo = {
                hostname: "s3-accesspoint-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
            };
            break;
        case "fips-accesspoint-us-west-1":
            regionInfo = {
                hostname: "s3-accesspoint-fips.us-west-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "fips-accesspoint-us-west-2":
            regionInfo = {
                hostname: "s3-accesspoint-fips.us-west-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "s3-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1",
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "s3.me-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "s3-external-1":
            regionInfo = {
                hostname: "s3-external-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1",
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "s3.sa-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "s3.us-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "s3.us-east-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "s3.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "s3.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "s3.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso",
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "s3.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b",
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "s3.us-west-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "s3.us-west-2.amazonaws.com",
                partition: "aws",
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_TEMPLATE.replace("{region}", region),
                    partition: "aws",
                };
            }
            if (AWS_CN_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                    partition: "aws-cn",
                };
            }
            if (AWS_ISO_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                    partition: "aws-iso",
                };
            }
            if (AWS_ISO_B_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                    partition: "aws-iso-b",
                };
            }
            if (AWS_US_GOV_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                    partition: "aws-us-gov",
                };
            }
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) {
                regionInfo = {
                    hostname: AWS_TEMPLATE.replace("{region}", region),
                    partition: "aws",
                };
            }
    }
    return Promise.resolve(__assign({ signingService: "s3" }, regionInfo));
};
//# sourceMappingURL=endpoints.js.map